import { BeltSyllabus } from './types';

export const redBelt: BeltSyllabus = {
    id: 'red',
    name: 'Red Belt',
    color: '#ff0000',
    theoryUnder13: [],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Hwa-Rang?',
                    answer: 'Hwa-Rang is named after the Hwa-Rang youth group, which originated in the Silla Dynasty in the early 7th Century. The 29 movements refer to the Republic of Korea\'s 29th Infantry Division, where Taekwon-Do developed into maturity.'
                },
                {
                    question: 'How many movements in Hwa-Rang?',
                    answer: '29'
                },
                {
                    question: 'What is the diagram of Hwa-Rang?',
                    answer: '/assets/diagrams/hwa_rang_diagram.png',
                    isImage: true
                },
                {
                    question: 'What does the Red Belt signify?',
                    answer: 'Red signifies danger, cautioning the student to exercise control and warning the opponent to stay away.'
                },
                {
                    question: 'What is Consecutive Motion?',
                    answer: 'Techniques that are performed in Consecutive Motion (Yonsok Tongjak) are when two or more techniques are performed using the same limb without landing or stopping between them.'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Palm Pushing Block', answer: 'Sonbadak Miro Makgi' },
                { question: 'X Knifehand Checking Block', answer: 'Kyocha Sonkal Mom-chwo Makgi' },
                { question: 'Twin Palm Upward Block', answer: 'Sang Sonbadak Ollyo Makgi' },
                { question: 'Side Front Block', answer: 'Yop Ap Makgi' },
                { question: 'Stepping', answer: 'Omgyo Didigi' },
                { question: 'Shifting', answer: 'Jajunbal' },
                { question: 'Reverse Hooking Kick', answer: 'Bandae Dollyo Goro Chagi' },
                { question: 'Flying Reverse Turning Kick', answer: 'Twimyo Bandae Dollyo Chagi' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'Fixed Stance U-Shape Block, Jump 360° Spin, land in L Stance Knifehand Guarding Block',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Walking Stance Upset Fingertip Low Thrust, L Stance Backfist Side Back Strike and Low Block (Slipping the Front Foot)',
                    answer: 'Forward X 4'
                },
                {
                    question: 'L Stance X Knifehand Checking Block, Walking Stance Twin Palm Upward Block. (The next combination starts by Moving the Front Foot)',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Turning Kick (Front Leg), Reverse Hooking Kick, Side Kick (Rear Leg) (Consecutive Motion)',
                    answer: 'Forward X 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Left and Right Back Piercing Kick',
                    answer: '2 Boards'
                },
                {
                    question: 'Left and Right Hand Technique (Student\'s Choice) (Different from previous grading)',
                    answer: '1 Board'
                },
                {
                    question: 'Flying Reverse Turning Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Chon-Ji to Hwa-Rang',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'From a Lying position, get up an evade / deal with an attack',
                    answer: ' '
                },
                {
                    question: 'Situational - Avoid Multiple Attackers (Pushes / Grabs / Hand / Foot Techniques)',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'One-Step Sparring',
                    answer: 'Any Technique'
                },
                {
                    question: 'Foot Sparring',
                    answer: ' ',
                    overrideTextLocation: 'start'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Fitness and Timed'
                },
                {
                    question: '2-v-1 Free Sparring',
                    answer: 'Movement (Do not go between) Counter Attacking'
                }
            ]
        }
    ]
};
